import React from "react";
import { Button } from "@mui/material";

const StripePaymentCancelled = () => {
  return (
    <div className="container d-flex align-items-center justify-content-center vh-100">
      <div
        className="text-center shadow-lg p-5 rounded"
        style={{
          backgroundColor: "#fff3f3",
        }}
      >
        <div className="mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="80"
            fill="red"
            className="bi bi-x-circle-fill"
            viewBox="0 0 16 16"
          >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
          </svg>
        </div>
        <h1 className="mb-3 text-danger">Payment Cancelled</h1>
        <p className="text-muted mb-4">
          It seems you cancelled the payment. If this was a mistake, please try again.
        </p>
      </div>
    </div>
  );
};

export default StripePaymentCancelled;
